




























import Vue from "vue";
import AppCheckbox from "@/components/AppCheckbox.vue";
export default Vue.extend({
  props: ["item", "isChecked"],
  components: {
    AppCheckbox,
  },
});
